/* No framework or animation: keep the two purchase points in sync. */
(() => {
  const root = document.querySelector('[data-magic-pdp]');
  if (!root) return;
  const choices = [...root.querySelectorAll('[data-magic-size]')];
  if (!choices.length) return;
  const buy = [...root.querySelectorAll('[data-magic-buy]')];
  function select(choice) {
    choices.forEach(input => { input.checked = input.value === choice.value; });
    buy.forEach(link => {
      link.setAttribute('aria-label', `Add MAGIC TOUCH ${choice.dataset.size} mL to cart for ${choice.dataset.price}`);
    });
  }
  choices.forEach(input => input.addEventListener('change', () => { if (input.checked) select(input); }));
  select(choices.find(input => input.checked) || choices[0]);
})();
